import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, handleError, formatCPF } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import * as defaultData from '../../../utils/DefaultData';

const masterProps = {
	title: 'Cadastro de Motoristas',
	subtitle: 'Gerencie o cadastro de motoristas',
};
const initialState = {
	driver: {
		id: null,
		name: '',
		description: '',
		document: '',
		nickName:'',
		licenseNumber: '',
		licenseCategory: '',
		licenseValid: null,
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	},
	term: '',
};
export default class Driver extends Component {
	state = { ...initialState };
	driver = {
		id: null,
		name: '',
		description: '',
		document: '',
		nickName:'',
		licenseNumber: '',
		licenseCategory: '',
		licenseValid: null,
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	};
	constructor(props) {
		super(props);
		this.loadListDrivers = this.loadListDrivers.bind(this);
		this.getDriver = this.getDriver.bind(this);
		this.deleteDriver = this.deleteDriver.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveDriver = this.saveDriver.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getDriver(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('drivers/' + key)
			.then(response => {
				this.driver = { ...response.data };
				this.setState({ ...this.state, driver: this.driver });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteDriver(key) {
		API.delete('drivers/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	saveDriver() {
		this.crudForm.current.showLoadingPanel(true);
		let driver = { ...this.driver };
		if (driver.id === null) {
			API.post('drivers/', driver)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					driver = response.data;
					this.driver = driver;
					this.setState({ driver: this.driver });
					// console.log(this.driver);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('drivers/' + driver.id, driver)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.driver = driver;
					this.setState({ driver: this.driver });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListDrivers(page, pageSize) {
		let term = this.state.term;
		return API.get('/drivers', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.drivers,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteDriver}
					fncGetData={this.getDriver}
					fncListData={this.loadListDrivers}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{
							dataField: 'document',
							caption: 'CPF',
							width: '20%',
							datatType: 'text',
							calculateCellValue: function(data) {
								return formatCPF(data.document);
							},
						},
						{ dataField: 'name', caption: 'Nome' },

						{ dataField: 'nickName', caption: 'Apelido' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						}
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.driver = { ...initialState.driver };
		this.setState({ ...this.state, driver: this.driver });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveDriver();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<Form formData={this.driver} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
				<GroupItem colCount={5} caption={'Informações Básicas'}>
					<SimpleItem
						dataField={'id'}
						cssClass="uppercase"
						label={{ text: 'Código' }}
						editorOptions={{ disabled: true }}
					/>
					<SimpleItem dataField={'enabled'} editorType={'dxCheckBox'} label={{ text: 'Ativo' }} colSpan={4} />

					<SimpleItem colSpan={3} dataField={'name'} cssClass="uppercase" label={{ text: 'Nome' }} />
					<SimpleItem
									dataField={'nickName'}
						cssClass="uppercase"
						label={{ text: 'Apelido' }}
					/>
					<SimpleItem
						dataField={'document'}
						editorOptions={{
							mask: '000.000.000-00',
						}}
						cssClass="uppercase"
						label={{ text: 'CPF' }}
					/>
					<SimpleItem
						dataField={'licenseCategory'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						colSpan={2}
						editorOptions={{
							items: defaultData.categoryLicenseDrive,
							searchEnabled: true,
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Categoria CNH' }}
					/>
					<SimpleItem
						colSpan={2}
						dataField={'licenseNumber'}
						cssClass="uppercase"
						label={{ text: 'Nº CNH' }}
					/>
					<SimpleItem
				
						dataField={'licenseValid'}
						editorType={'dxDateBox'}
						editorOptions={{
							displayFormat: 'dd/MM/yyyy',
						}}
						label={{ text: 'Validade CNH' }}
					/>
				</GroupItem>
				<GroupItem colCount={3} caption={'Informações de Contato'}>
					<SimpleItem
						colSpan={3}
						dataField={'contactInformation.name'}
						cssClass="uppercase"
						label={{ text: 'Nome de Contato', showColon: false }}
					/>
					<SimpleItem
						colSpan={3}
						dataField={'contactInformation.email'}
						label={{ text: 'E-mail', showColon: false }}
					/>
					<SimpleItem
						dataField={'contactInformation.phoneNumber'}
						editorOptions={{
							mask: '(00) 00000-0000',
						}}
						label={{ text: 'Celular', showColon: false }}
					/>
					<SimpleItem
						dataField={'contactInformation.homePhoneNumber'}
						editorOptions={{
							mask: '(00) 0000-0000',
						}}
						label={{ text: 'Telefone Residencial', showColon: false }}
					/>
					<SimpleItem
						dataField={'contactInformation.businessPhoneNumber'}
						editorOptions={{
							mask: '(00) 0000-0000',
						}}
						label={{ text: 'Telefone Comercial', showColon: false }}
					/>
				</GroupItem>
				<GroupItem>
					<div className="pull-right">
						<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
							<i className="fa fa-plus" />
							&nbsp; Novo
						</button>
						<button type="button" className="btn btn-success" onClick={this.onClickSave}>
							<i className="fa fa-check" />
							&nbsp; Salvar
						</button>
					</div>
				</GroupItem>
			</Form>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
